import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {ContactInfoService} from "../../Services/contact-info/contact-info.service";
import {CookieService} from 'angular2-cookie/services/cookies.service';

@Component({
  selector: 'app-edit-info',
  templateUrl: './edit-info.component.html',
  styleUrls: ['./edit-info.component.scss']
})
export class EditInfoComponent implements OnInit {

  @Output() close = new EventEmitter();


  contactInfo: ContactInfoService;

  constructor(contactInfo: ContactInfoService) {
    this.contactInfo = contactInfo;
  }

  ngOnInit() {
  }

  submitForm() {
    let error = false;
    let inps = document.getElementsByClassName('edit-info-inp');
    for ( var i = 0; i < inps.length; i++ ) {

      let inp = <HTMLInputElement>inps[i];

      if ( inp.value.length < 1 ) {
        inp.classList.add('err');
        error = true;
      } else {
        inp.classList.remove('err');
      }

      if ( inp.type === 'email' ) {
        let regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        let emailDomain = inp.value.split('@')[1];
        if ( !regex.test( inp.value ) || emailDomain === undefined || (this.contactInfo.freeEmailProviders !== [] && this.contactInfo.freeEmailProviders.includes(emailDomain)) ) {
          inp.classList.add('err');
          error = true;
        } else {
          inp.classList.remove('err');
        }
      }

      if ( inp.type === 'tel' ) {
        // let regex = /^\d+$/;
        let regex1 = new RegExp(/(.)(\1){9,}/);
        let regex2 = new RegExp(/^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3,4}[-\s\.]?[0-9]{4,6}$/,"i");
        if ( regex1.test( inp.value ) || !regex2.test( inp.value ) ) {
          inp.classList.add('err');
          error = true;
        } else {
          inp.classList.remove('err');
        }
      }
    }

    if ( !error ) {
      this.close.emit();
    } else {
      return false;
    }
  }

  onKeyUp(event: any) {
    if ( event.target.value.length < 1 ) {
      event.target.classList.add('err');
    } else {
      event.target.classList.remove('err');
    }
  }

  onKeyUpPhone(event: any) {
    // let regex = /^\d+$/;
    let regex1 = new RegExp(/(.)(\1){9,}/);
    let regex2 = new RegExp(/^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3,4}[-\s\.]?[0-9]{4,6}$/,"i");
    if ( regex1.test( event.target.value ) || !regex2.test( event.target.value ) ) {
      event.target.classList.add('err');
    } else {
      event.target.classList.remove('err');
    }
  }

  onKeyUpEmail(event: any) {
    let regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    let emailDomain = event.target.value.split('@')[1];
    if ( !regex.test( event.target.value ) || emailDomain === undefined || (this.contactInfo.freeEmailProviders !== [] && this.contactInfo.freeEmailProviders.includes(emailDomain)) ) {
      event.target.classList.add('err');
    } else {
      event.target.classList.remove('err');
    }
  }

}



// WEBPACK FOOTER //
// /app/src/app/Components/edit-info/edit-info.component.ts